function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import env from '../env';
import Backbone from '@polleverywhere/backbone';
/*
 * Powerpoint presentation model that monitors the presentation API.
 */

var RemoteControl = /*#__PURE__*/function () {
  function RemoteControl(options) {
    if (options === void 0) {
      options = {};
    }

    this.user = options.user;
  } // Determine when state has changed


  var _proto = RemoteControl.prototype;

  _proto.hasChanged = function hasChanged() {
    var currentState = this.states.currentState;
    var priorState = this.states.priorState;
    return currentState.index !== priorState.index || currentState.status !== priorState.status;
  } // Check powerpoint state and look for changes
  ;

  _proto.fetchState = function fetchState(presentation) {
    this.states.priorState = this.states.currentState;
    this.states.currentState = {
      presenting: presentation.isPresenting(),
      index: presentation.currentSlide(),
      slides_count: presentation.totalSlides(),
      title: presentation.title(),
      notes: presentation.notes(),
      poll_url: presentation.pollUrl()
    };
    return this.states.currentState;
  } // Send information about changed state to firehose subscribers
  ;

  _proto.putState = function putState() {
    if (this.user) {
      return Backbone.ajax({
        url: env.get('api_url').segment('api/presentations').segment(this.user.get('id').toString()).segment('sync').toString(),
        contentType: 'application/json',
        processData: false,
        data: JSON.stringify({
          presentation: this.states.currentState
        }),
        type: 'PUT'
      });
    }
  }
  /*
   * Contiuous loop for pulling state from presentation API
   * pulling over setInterval will be removed when presentation API develops event firing
   */
  ;

  _proto.start = function start(presentation) {
    var _this = this;

    this.presentation = presentation;
    setInterval(function () {
      _this.fetchState(_this.presentation);

      if (_this.hasChanged()) {
        return _this.putState();
      }
    }, 500);
  };

  _createClass(RemoteControl, [{
    key: "states",
    get: function get() {
      return {
        currentState: {},
        priorState: {}
      };
    }
  }]);

  return RemoteControl;
}();

export { RemoteControl as default };